/// <amd-module name="Reporting/Visuals/VisualMessages/ActionRequiredContent" />
import React = require("react");
import { VisualTitle } from "Reporting/Visuals/VisualTitle";
import { VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";

export interface ActionRequiredContentProps {
    visualTitle: string;
    onClick?: (event: React.SyntheticEvent<any> | React.SyntheticEvent<any>) => void;
}

/** Initial card presentation for WidgetHost  */
export class ActionRequiredContent extends VssComponent<ActionRequiredContentProps, {}> {
    public render(): JSX.Element {
        return (
            <Button className="action-required-content" subtle={true} onClick={this.props.onClick}>
                <VisualTitle text={this.props.visualTitle} />
                <div className="action-required-grid-container">
                    <div className="action-required-grid" />
                </div>
            </Button>
        );
    }
}
